module.exports = __webpack_public_path__ + "img/seal.db0db688.svg";